export enum ZIconType {
    /** Statuses */
    Information,
    Alert,
    Error,
    Check,
    Connected,
    Disconnected,

    /** Actions */
    Search,
    Close,
    Add,
    Edit,
    Delete,
    Merge,
    Upload,
    Download,
    Sync,
    Refresh,
    NewTab,
    Print,
    Save,
    Compare,
    Link,
    Zoom,
    DrillDown,
    Lock,
    Unlock,

    /** Info */
    Star,
    StarOutline,
    System,
    File,
    Expand,

    /** Formatting */
    Price,
    Percent,

    /** File Types */
    Excel,
    PDF,

    /** Misc. */
    ArrowUp,
    ArrowDown,
    CogOutline,


    Copy,

    /** Added icons */
    Mail,
    Globe,
    Phone,

    Unknown,
}

const IconMap: Record<ZIconType, string> = {
    /** Statuses */
    [ZIconType.Information]: "mdi-information",
    [ZIconType.Alert]: "mdi-alert",
    [ZIconType.Error]: "mdi-alert-circle-outline",
    [ZIconType.Check]: "mdi-check",
    [ZIconType.Connected]: "mdi-wifi",
    [ZIconType.Disconnected]: "mdi-wifi-off",

    /** Actions */
    [ZIconType.Search]: "mdi-magnify",
    [ZIconType.Close]: "mdi-close",
    [ZIconType.Add]: "mdi-plus",
    [ZIconType.Edit]: "mdi-pencil",
    [ZIconType.Delete]: "mdi-trash-can-outline",
    [ZIconType.Merge]: "mdi-call-merge",
    [ZIconType.Upload]: "mdi-tray-arrow-up",
    [ZIconType.Download]: "mdi-tray-arrow-down",
    [ZIconType.Sync]: "mdi-cloud-sync",
    [ZIconType.Refresh]: "mdi-autorenew",
    [ZIconType.NewTab]: "mdi-open-in-new",
    [ZIconType.Print]: "mdi-printer",
    [ZIconType.Save]: "mdi-content-save-outline",
    [ZIconType.Compare]: "mdi-compare-horizontal",
    [ZIconType.Link]: "mdi-link-variant",
    [ZIconType.Zoom]: "mdi-magnify-plus-outline",
    [ZIconType.DrillDown]: "mdi-magnify-expand",
    [ZIconType.Lock]: "mdi-lock-outline",
    [ZIconType.Unlock]: "mdi-lock-open-outline",

    /** Info */
    [ZIconType.Star]: "mdi-star",
    [ZIconType.StarOutline]: "mdi-star-outline",
    [ZIconType.System]: "mdi-cog",
    [ZIconType.File]: "mdi-file",
    [ZIconType.Expand]: "mdi-arrow-expand-all",

    /** Formatting */
    [ZIconType.Price]: "mdi-currency-usd",
    [ZIconType.Percent]: "mdi-percent-outline",

    /** File Types */
    [ZIconType.Excel]: "mdi-microsoft-excel",
    [ZIconType.PDF]: "mdi-file-pdf-box",

    /** Misc. */
    [ZIconType.ArrowUp]: "mdi-chevron-up",
    [ZIconType.ArrowDown]: "mdi-chevron-down",
    [ZIconType.CogOutline]: "mdi-cog-outline",


    [ZIconType.Copy]: "mdi-content-copy",

    /** Added icons */
    [ZIconType.Mail]: "mdi-email",
    [ZIconType.Globe]: "mdi-earth",
    [ZIconType.Phone]: "mdi-phone",

    [ZIconType.Unknown]: "mdi-square",
}

export const getIconString = (icon: ZIconType): string => {
    if (!(icon in IconMap)) {
        console.error("Trying to retrieve an icon that doesn't exist in the icon map! Tried to retrieve " + ZIconType[icon]);
        return `mdi ${IconMap[ZIconType.Unknown]}`;
    }
    return `mdi ${IconMap[icon]}`;
}